import { createSlice } from "@reduxjs/toolkit";

export const initialUnitTypeLocalState = {
  id: null,
  unitTypeName: null,
  storageType: null,
  sizeFt3: null,
  unitWidth: null,
  unitLength: null,
  unitHeight: null,
  rentType: null,
  prefix: null,
  pricePerUnit: null,
  unitNumbering: "Sequential Numbering",
  quantity: null,
  siteAccessHours: null,
  accessStartTime: null,
  accessEndTime: null,
  securityDepositType: null,
  securityDepositValue: null,
};

export const initialSiteUnitLocalState = {
  id: null,
  unitTypeId: null,
  storageType: null,
  sizeFt3: null,
  unitWidth: null,
  unitLength: null,
  unitHeight: null,
  rentType: null,
  prefix: null,
  rangeStart: null,
  rangeEnd: null,
  pricePerUnit: null,
  unitNumbering: "Sequential Numbering",
  quantity: null,
  siteAccessHours: null,
  accessStartTime: null,
  accessEndTime: null,
  securityDepositType: null,
  securityDepositValue: null,
};

export const initialSiteLocalState = {
  id: null,
  siteName: null,
  address: null,
  postcode: null,
  status: null,
  numberOfFloors: null,
  numberOfAisles: null,
  numberOfRowsPerAisle: null,
  numberOfBaysPerRow: null,
  siteType: null,
  countryCode: null,
  phone: null,
  numberOfUnits: null,
};

const initialState = {
  unitTypeSummarys: [],
  unitTypeDetails: null,
  newUnitTypeLocal: initialUnitTypeLocalState,
  userRoles: [],
  pagination: {},
  isAddUnitTypeSuccess: false,
  isDeleteResponseSuccess: false,
  isUpdateUnitTypeSuccess: false,
  sites: [],
  sitePagination: {},
  siteDetails: null,
  isAddSiteSuccess: false,
  isDeleteSiteResponseSuccess: false,
  isUpdateSiteSuccess: false,
  siteUnitList: [],
  siteUnitPagination: {},
  addSiteUnitResponse: false,
  singleSiteUnitResponse: {},
  isDeletedSiteUnitResponse: false,
  isSiteUnitStatusResponse: false,
  siteListTotalSites: null,
  siteListAvailableSites: null,
  storageSettings: {},
};

export const storageSettingSlice = createSlice({
  name: "storageSetting",
  initialState,
  reducers: {
    getStorageSettingsAction: (state) => {},
    setStorageSettingsAction: (state, { payload }) => {
      state.storageSettings = payload;
    },
    updateStorageSettingsAction: (state, { payload }) => {},

    getAllUnitTypesAction: (state, { payload }) => {},
    setAllUnitTypesAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.unitTypeSummarys = list;
      state.pagination = pagination;
    },

    addUnitTypeAction: (state, { payload }) => {},
    setAddUnitTypeResponse: (state, { payload }) => {
      state.isAddUnitTypeSuccess = payload;
    },

    getSingleUnitTypeAction: (state, { payload }) => {},
    setSingleUnitTypeAction: (state, { payload }) => {
      state.unitTypeDetails = payload;
    },

    deleteUnitTypeAction: (state, { payload }) => {},
    setDeleteUnitTypeResponse: (state, { payload }) => {
      state.isDeleteResponseSuccess = payload;
    },

    setNewUnitTypeLocal: (state, action) => {
      state.newUnitTypeLocal = action.payload;
    },
    resetNewUnitTypeLocal: (state) => {
      state.newUnitTypeLocal = initialUnitTypeLocalState;
    },

    updateUnitTypeAction: (state, { payload }) => {},
    setUpdateUnitTypeResponse: (state, { payload }) => {
      state.isUpdateUnitTypeSuccess = payload;
    },

    getAllSitesAction: (state, { payload }) => {},
    setAllSitesAction: (state, { payload }) => {
      const {
        pagination = { currentPage: 1 },
        list = [],
        totalSites,
        availableSites,
      } = payload;
      state.sites = list;
      state.sitePagination = pagination;
      state.siteListTotalSites = totalSites;
      state.siteListAvailableSites = availableSites;
    },

    addSiteAction: (state, { payload }) => {},
    setAddSiteResponse: (state, { payload }) => {
      state.isAddSiteSuccess = payload;
    },

    getSingleSitesAction: (state, { payload }) => {},
    setSingleSitesAction: (state, { payload }) => {
      state.siteDetails = payload;
    },

    getSiteUnitListAction: (state, { payload }) => {},
    setSiteUnitListResponse: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.siteUnitList = list;
      state.siteUnitPagination = pagination;
    },

    addSiteUnitAction: (state, { payload }) => {},
    updateSiteUnitAction: (state, { payload }) => {},
    setAddSiteUnitResponse: (state, { payload }) => {
      state.addSiteUnitResponse = payload;
    },

    // storage reducer
    clearUnitTypeDetails: (state) => {
      state.unitTypeDetails = null;
    },

    getSingleSiteUnitAction: (state, { payload }) => {},
    setSingleSiteUnitResponse: (state, { payload }) => {
      state.singleSiteUnitResponse = payload;
    },

    deleteSiteUnitAction: (state, { payload }) => {},
    setDeleteSiteUnitResponse: (state, { payload }) => {
      state.isDeletedSiteUnitResponse = payload;
    },

    updateSiteUnitStatusAction: (state, { payload }) => {},
    updateSiteUnitStatusResponse: (state, { payload }) => {
      state.isSiteUnitStatusResponse = payload;
    },
  },
});

const {
  getStorageSettingsAction,
  setStorageSettingsAction,
  updateStorageSettingsAction,
  getAllUnitTypesAction,
  setAllUnitTypesAction,
  addUnitTypeAction,
  setAddUnitTypeResponse,
  setNewUnitTypeLocal,
  resetNewUnitTypeLocal,
  deleteUnitTypeAction,
  setDeleteUnitTypeResponse,
  getSingleUnitTypeAction,
  setSingleUnitTypeAction,
  updateUnitTypeAction,
  setUpdateUnitTypeResponse,
  getAllSitesAction,
  setAllSitesAction,
  addSiteAction,
  setAddSiteResponse,
  getSingleSitesAction,
  setSingleSitesAction,
  getSiteUnitListAction,
  setSiteUnitListResponse,
  clearUnitTypeDetails,
  addSiteUnitAction,
  setAddSiteUnitResponse,
  updateSiteUnitAction,
  getSingleSiteUnitAction,
  setSingleSiteUnitResponse,
  deleteSiteUnitAction,
  setDeleteSiteUnitResponse,
  updateSiteUnitStatusAction,
  updateSiteUnitStatusResponse,
} = storageSettingSlice.actions;

export {
  getStorageSettingsAction,
  setStorageSettingsAction,
  updateStorageSettingsAction,
  getAllUnitTypesAction,
  setAllUnitTypesAction,
  addUnitTypeAction,
  setAddUnitTypeResponse,
  setNewUnitTypeLocal,
  resetNewUnitTypeLocal,
  deleteUnitTypeAction,
  setDeleteUnitTypeResponse,
  getSingleUnitTypeAction,
  setSingleUnitTypeAction,
  updateUnitTypeAction,
  setUpdateUnitTypeResponse,
  clearUnitTypeDetails,
  getAllSitesAction,
  setAllSitesAction,
  addSiteAction,
  setAddSiteResponse,
  getSingleSitesAction,
  setSingleSitesAction,
  getSiteUnitListAction,
  setSiteUnitListResponse,
  addSiteUnitAction,
  setAddSiteUnitResponse,
  updateSiteUnitAction,
  getSingleSiteUnitAction,
  setSingleSiteUnitResponse,
  deleteSiteUnitAction,
  setDeleteSiteUnitResponse,
  updateSiteUnitStatusAction,
  updateSiteUnitStatusResponse,
};

export default storageSettingSlice.reducer;
